import React from "react";

import ReactDOM from "react-dom";

import {
  EmailSignUpForm,
  EmailSignUpForm as MUIEmailSignUpForm,
  GoogleOneTap,
  LoginForm,
  LoginForm as MUILoginForm,
  ModalController,
} from "@skillshare/ui-components/components/authentication";
import { Button } from '@skillshare/ui-components/components/buttons';
import { Providers } from "@skillshare/ui-components/shared/providers";

import AuthPopup from "../utils/auth-popup";
import { ReactBoneIntlProvider } from "../utils/reactbone-intl-provider";
import { shouldMUIAuth, shouldRenderAuth0Popup, shouldShowAuth0 } from "../views/modules/flags";

const { openAuth0DOMPopup } = AuthPopup;

const getVariables = () => {
  return {
    appHost: document.location.origin,
    appleClientId: SS?.serverBootstrap?.appleClientId,
    csrfToken: $.cookie("YII_CSRF_TOKEN"),
    facebookId: $("#fb-id").val(),
    googleClientId: SS?.serverBootstrap?.googleClientId,
    nonce: SS?.serverBootstrap?.nonce,
    siteKey: SS?.serverBootstrap?.gRecaptcha?.siteKey,
    auth0Redirect: '/auth0/login', //TBD externalize somehow
  };
}
const AuthHelper = {
  initialize: function (rootElement, component) {
    const {
      appHost,
      appleClientId,
      csrfToken,
      facebookId,
      googleClientId,
      nonce,
      siteKey,
    } = getVariables();
    const trackEventHandler = SS.EventTracker.trackingCallback();
    const domain = SS?.serverBootstrap?.auth0?.tenantDomain;
    const clientId = SS?.serverBootstrap?.auth0?.clientId;

    ReactDOM.unmountComponentAtNode(rootElement);
    ReactDOM.render(
      <Providers
        auth0ProviderProps={{
          domain: domain,
          clientId: clientId,
          redirectUri: this.getRedirectTo(),
        }}
        cookieProviderProps={{ cookies: { YII_CSRF_TOKEN: csrfToken } }}
        cspProviderProps={{ nonce }}
        defaultThemeProviderProps
        environmentProviderProps={{
          variables: {
            recaptcha: { siteKey },
            facebookId,
            googleClientId,
            appleClientId,
            appHost,
          },
        }}
        eventsProviderProps={{ trackEventHandler }}
      >
        <ReactBoneIntlProvider>{component}</ReactBoneIntlProvider>
      </Providers>,
      rootElement
    );
  },

  initializeTwoPanelSignUpView: function ({
    scope,
    redirectTo,
    authType,
    openOnLoad,
    data,
    showEmailSignUp,
  }) {
    const rootElement = scope.$(".click-off-overlay").get(0);
    if (!rootElement) {
      return;
    }
    this.initialize(
      rootElement,
      <ModalController
        authType={authType}
        requiresTrigger={false}
        openOnLoad={openOnLoad}
        loginData={data.loginData}
        signUpData={data.signUpData}
        redirectTo={redirectTo}
        showEmailSignUp={showEmailSignUp ? showEmailSignUp : false}
        showAuth0={shouldShowAuth0()}
        showPopup={shouldRenderAuth0Popup()}
      />
    );
  },

  initializeAuthForm: function ({
    rootElement,
    redirectTo,
    showSocialLogins,
    isLogin,
    team,
  }) {
    const { auth0Redirect } = getVariables();
    // gr_mui_auth
    if (shouldMUIAuth()) {
      this.initialize(
        rootElement,
        isLogin ? (
          (shouldRenderAuth0Popup() ? 
            <Button
              text={'Sign In with Popup'}
              className={`full-width submit-btn`}
              onClick={openAuth0DOMPopup}
              loading={false}
            />
            :
            <MUILoginForm
              redirectTo={redirectTo}
              showSocialLogins={showSocialLogins}
              isModal={false}
              team={team}
              showAuth0={shouldShowAuth0()}
              auth0Redirect={auth0Redirect}
            />
          )
        ) : (
          <MUIEmailSignUpForm
            redirectTo={redirectTo}
            showSocialLogins={showSocialLogins}
            isModal={false}
            team={team}
          />
        )
      );
    } else {
      this.initialize(
        rootElement,
        isLogin ? (
          (shouldRenderAuth0Popup() ?
            <Button
              text={'Sign In with Popup'}
              className={`full-width submit-btn`}
              onClick={openAuth0DOMPopup}
              loading={false}
            />
            :
            <LoginForm
              redirectTo={redirectTo}
              showSocialLogins={showSocialLogins}
              isModal={false}
              team={team}
              showAuth0={shouldShowAuth0()}
              auth0Redirect={auth0Redirect}
            />
          )
        ) : (
          <EmailSignUpForm
            redirectTo={redirectTo}
            showSocialLogins={showSocialLogins}
            isModal={false}
            team={team}
          />
        )
      );
    }
  },

  getRedirectTo: function () {
    return (
      SS.serverBootstrap?.pageData?.redirectTo ??
      SS.serverBootstrap?.loginPopupRedirectTo ??
      SS.serverBootstrap?.signupPopupRedirectTo ??
      null
    );
  },

  getOneTapTop: function () {
    const isSiteBannerVisible = $("#site-banner").length > 0;
    const isLoH = location.pathname === "/";
    if (isSiteBannerVisible) {
      return 90;
    } else if (isLoH) {
      return 66;
    }
    return 58;
  },

  initializeGoogleOneTouch: function () {
    if (!SS.currentUser.isGuest() || !$("#google-ot-container").length) {
      return;
    }

    const { appHost, csrfToken, googleClientId, nonce } = getVariables();
    const redirectTo = this.getRedirectTo();
    const top = this.getOneTapTop();
    const addEmbeddedSignUpClass = () => {
      const element = $(".embedded-signup");

      if (element.length) {
        element.addClass("embedded-signup--one-tap");
      }
    };

    ReactDOM.render(
      <Providers
        cookieProviderProps={{ cookies: { YII_CSRF_TOKEN: csrfToken } }}
        cspProviderProps={{ nonce }}
        defaultThemeProviderProps
        environmentProviderProps={{ variables: { googleClientId, appHost } }}
      >
        <ReactBoneIntlProvider>
          <GoogleOneTap
            autoSelect={false}
            left="auto"
            right="16px"
            top={`${top}px`}
            redirectTo={redirectTo}
            onRenderOneTap={addEmbeddedSignUpClass}
          />
        </ReactBoneIntlProvider>
      </Providers>,
      $("#google-ot-container").get(0)
    );
  },
};

export default AuthHelper;
